export default {
  pt: {
    pageTitle: "Termos",
    mainTitle: "Termos de Serviço",
    attentionTitle: "Atenção",
    attentionText: "A aceitação do risco de seguros é critério exclusivo da seguradora.",
    acceptButton: "Aceitar",
    declineButton: "Recusar",
  },

  en: {
    pageTitle: "Terms",
    mainTitle: "Terms of Service",
    attentionTitle: "Attention",
    attentionText: "The acceptance of insurance risk is the exclusive criterion of the insurer.",
    acceptButton: "Accept",
    declineButton: "Decline",
  },
}; 